import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
export default function isNewestOnBottom() {
    var userConfiguration = getUserConfiguration();
    var sortOrderFromOptions = userConfiguration.UserOptions
        ? userConfiguration.UserOptions.ConversationSortOrderReact
        : 'ChronologicalNewestOnBottom';
    return sortOrderFromOptions == 'ChronologicalNewestOnBottom';
}
//# sourceMappingURL=isNewestOnBottom.js.map